// Trivia Night set geometry (table-local, floor origin, metres, +Y up, the
// audience stands on +Z). Shared by the props, the live screen and the VR panel.

export const SCREEN_W = 4.0;
export const SCREEN_H = 2.25;
/** Screen centre height (bottom edge ~1.3 m, readable over a crowd). */
export const SCREEN_Y = 2.45;
/** Screen face plane (the live content sits just in front of it). */
export const SCREEN_Z = -0.45;
export const FACE_Z = SCREEN_Z + 0.07;

/** Host podium, front-left of the screen, facing the audience. */
export const PODIUM_X = -1.65;
export const PODIUM_Z = 0.5;
export const PODIUM_TOP = 1.1;

/** Builder pick box (height is always GT_H). */
export const TRIVIA_FOOTPRINT = { w: 4.6, d: 1.8 };

/** Answer colours A–D (also the overlay's --tv-* tokens). */
export const ANSWER_COLORS = ['#e2384d', '#2f7df6', '#f2a516', '#22b573'];
export const ANSWER_DIM = ['#4a1a22', '#17304f', '#4d3a12', '#14402f'];
export const LETTERS = ['A', 'B', 'C', 'D'];
